/**
 * Centralised UI feature flags.
 *
 * Flip `SHOW_REWARDS` to `true` to re-enable the reward field on
 * ReportCasePage and the reward display on CaseDetailPage. Backend
 * already accepts/serves `reward_amount`, so nothing else changes.
 */
export const FEATURES = {
  // Hidden 2026-02 per user request — will be re-enabled when MISYOU
  // formally launches a reward / bounty programme.
  SHOW_REWARDS: false,
  // Stripe checkout — HIDDEN 2026-08-09. Stripe India is invite-only and
  // our activation is still pending. Code path preserved; flip back to
  // `true` once Stripe issues a `sk_live_*` key. The backend routes are
  // untouched so we can re-enable in one line.
  STRIPE_ENABLED: false,
  // Paytm PG — LIVE (production). Went live 2026-07-14 with production
  // MID SxBuxF12660177778489. Backend routes to secure.paytmpayments.com
  // when PAYTM_ENV=PRODUCTION. Flip PAYTM_ENV=STAGING in Emergent Secrets
  // to temporarily route back to the sandbox (securestage.paytmpayments.com)
  // without touching this flag. Do NOT flip this flag to false to disable
  // Paytm — that also unhooks the tile from the UI. Flip PAYTM_ENABLED=false
  // only if we decide to drop the gateway entirely.
  PAYTM_ENABLED: true,
  // Instamojo PG — HIDDEN 2026-08-09. Merchant KYC is still under review
  // by Instamojo/Cashfree's payment partners (previous "approved" banner
  // was misread). Backend routes + secrets remain; only the UI is hidden.
  // Flip back to `true` on the day Instamojo confirms real activation.
  INSTAMOJO_ENABLED: false,
  // SabPaisa PG — LIVE (production) 2026-02-19. Merchant MISY1.
  // Backend /api/payments/sabpaisa/* endpoints verified with a real
  // create-order call to checkout.sabpaisa.in (HTTP 200 + checkoutUrl).
  // Toggle back to `false` if we ever need to hide the tile without
  // touching backend routes.
  SABPAISA_ENABLED: true,
};
